import { ScrollIndicator } from "@src/app/scroll_indicator";

const MAX_ANIMATE_TIME = 380;

export function scrollToAnimated(finalY: number, scrollIndicator: ScrollIndicator): () => void {
  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    document.body.removeEventListener('click', finish);
    document.body.removeEventListener('touchstart', finish);
    scrollIndicator.activate();
  };
  document.body.addEventListener('click', () => finish);
  document.body.addEventListener('touchstart', () => finish);

  scrollIndicator.deactivate();

  finalY = Math.min(finalY, document.body.scrollHeight - window.innerHeight);

  let initialScroll = window.scrollY;
  const direction = Math.sign(finalY - initialScroll);
  let totalDistance = Math.abs(finalY - initialScroll);

  const maxAnimateDistance = window.innerHeight * 0.9;
  let firstScrollIsJump = false;
  if (totalDistance > maxAnimateDistance) {
    initialScroll = maxAnimateDistance * -1 * direction + finalY;
    totalDistance = maxAnimateDistance;
    firstScrollIsJump = true;
  }

  let animationRatio = Math.min(1, totalDistance / maxAnimateDistance);
  if (!firstScrollIsJump) {
    // Move one frame into the future if we didn't already scroll so that the first
    // frame starts moving.
    animationRatio = Math.max(0, 1 - (1 / 60));
  }
  const startTime = Date.now();
  const totalTime = animationRatio * MAX_ANIMATE_TIME;

  const doScroll = () => {
    if (finished) return;

    const timePassed = Date.now() - startTime;
    if (timePassed >= totalTime) {
      window.scrollTo(0, finalY);
      finish();
      return;
    }

    let percent = (1 - animationRatio) + (timePassed / totalTime) * animationRatio;
    percent = easeOutCirc(percent);
    const y = initialScroll + direction * (totalDistance * percent);
    window.scrollTo(0, y);

    requestAnimationFrame(doScroll);
  };
  doScroll();

  return finish;
}

// From https://easings.net/#easeOutCirc
function easeOutCirc(x: number): number {
  const clampedX = Math.max(0, Math.min(1, x));
  return Math.sqrt(1 - Math.pow(clampedX - 1, 2));
}